const initialState = {
  filters: [],
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SAVE_FILTER':
      return {...state, filters: action.payload};
    default:
      return state;
  }
};

export default profileReducer;
